import { FluxHazards } from '@energy-retailer/constants';
import { z } from 'zod';

export const hazardzSchema = z
  .object({
    hasHazard: z
      .boolean()
      .optional()
      .superRefine((value, ctx) => {
        if (value === undefined) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Please select an option',
          });
          return false;
        }
        return true;
      }),
    hazards: z.array(z.nativeEnum(FluxHazards)).optional(),
    otherNote: z.string().optional(),
  })
  .superRefine((value, ctx) => {
    if (value.hasHazard) {
      const hazards = value.hazards;
      if (hazards && hazards.length > 0) {
        if (
          hazards.includes(FluxHazards.Other) &&
          (value.otherNote === undefined || value.otherNote === '')
        ) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Please provide hazard(s) details',
            path: ['otherNote'],
          });
          return false;
        }
        return true;
      }
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Please select hazard(s)',
        path: ['hazards'],
      });
      return false;
    }
    return true;
  });

export type HazardsSchema = z.infer<typeof hazardzSchema>;
